import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';

const Support = () => {
  const services = [
    {
      icon: FiIcons.FiLifeBuoy,
      title: 'Asistencia Remota',
      description: 'Soporte técnico inmediato sin necesidad de desplazamientos. Resolvemos la mayoría de incidencias en minutos.'
    },
    {
      icon: FiIcons.FiTruck,
      title: 'Soporte Presencial',
      description: 'Cuando la situación lo requiere, nuestros técnicos acuden a sus instalaciones para resolver problemas in situ.'
    },
    {
      icon: FiIcons.FiZap,
      title: 'Resolución Rápida',
      description: 'Priorizamos las incidencias según su impacto en su negocio, minimizando los tiempos de inactividad.'
    },
    {
      icon: FiIcons.FiBarChart2,
      title: 'Optimización de Rendimiento',
      description: 'Mejoramos la velocidad y eficiencia de sus equipos para maximizar la productividad.'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Soporte Técnico Rápido y Eficaz
        </h1>

        <div className="mb-12">
          <p className="text-lg text-gray-600 mb-6 text-center max-w-4xl mx-auto">
            Cuando surge un problema informático, cada minuto cuenta. Nuestro equipo de soporte está preparado para resolver cualquier incidencia de forma rápida y eficiente, minimizando el impacto en su negocio.
          </p>
        </div>

        {/* Servicios de Soporte */}
        <section className="mb-16">
          <h2 className="text-3xl font-semibold text-center mb-8">
            Nuestras Soluciones de Soporte
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                <SafeIcon icon={service.icon} className="h-12 w-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Beneficios */}
        <section className="mb-16">
          <h2 className="text-3xl font-semibold text-center mb-8">
            Ventajas de Nuestro Soporte Técnico
          </h2>
          <div className="bg-blue-50 p-8 rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start">
                <SafeIcon icon={FiIcons.FiClock} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold mb-2">Tiempo de Respuesta Garantizado</h3>
                  <p className="text-gray-600">Nos comprometemos a responder a sus incidencias en menos de 2 horas</p>
                </div>
              </div>
              <div className="flex items-start">
                <SafeIcon icon={FiIcons.FiUsers} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold mb-2">Técnicos Certificados</h3>
                  <p className="text-gray-600">Profesionales con amplia experiencia y certificaciones oficiales</p>
                </div>
              </div>
              <div className="flex items-start">
                <SafeIcon icon={FiIcons.FiLayers} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold mb-2">Soluciones Permanentes</h3>
                  <p className="text-gray-600">No solo arreglamos el problema, identificamos y corregimos la causa raíz</p>
                </div>
              </div>
              <div className="flex items-start">
                <SafeIcon icon={FiIcons.FiHeadphones} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold mb-2">Soporte Multicanal</h3>
                  <p className="text-gray-600">Atención por teléfono, email, chat y sistema de tickets</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <div className="bg-blue-600 text-white p-8 rounded-lg text-center">
          <h2 className="text-2xl font-semibold mb-4">¿Necesita ayuda con un problema informático?</h2>
          <p className="mb-6">Contacte con nuestro equipo de soporte técnico y resolveremos su incidencia a la mayor brevedad.</p>
          <Link to="/contacto" className="inline-block bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-100 transition-colors">
            Contactar ahora
          </Link>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Support;